import { Link } from 'shared/ui/link-base';
import { CompanyDto } from '@sr/dto';
import { companyLinkManager } from 'utils/link-manager';
import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

type Props = {
  children?: ReactNode,
  company: Pick<CompanyDto, 'id' | 'name'>,
}

export const LinkToCompany = ({ company: { id, name }, children }: Props) => {
  const location = useLocation();
  const link = companyLinkManager.link(id);
  return (
    <Link to={link} state={{ from: `${location.pathname}${location.search}` }}>
      {children ? children : name}
    </Link>
  );
}
